import { PaymentResource } from '../../classes/Api/Payment'

export let savePaymentState = function(payments, invoice_id) {
    return new Promise((resolve, reject) => {
        // Retrieve all of the current payments for the invoice.
        PaymentResource.all({ 
            filters: JSON.stringify({
                'invoice.invoice_number': invoice_id
            })
        }).then((response) => {

            // Remove any payments that are not in the current array.
            for (let i in response.data.results) {
                let item = payments.find((payment) => {
                    return payment.id === response.data.results[i].id;
                });

                if (!item) {
                    PaymentResource.destroy(
                        response.data.results[i].id
                    ).then((response) => {}, reject);
                }
            }

            // If there are no payments, for instance when the PX covers 
            // the balance of the new vehicle, we resolve here.
            if (0 === payments.length) {
                resolve(payments);
                return;
            }

            // Save the payments.
            let savedPayments = 0;

            for (let i in payments) {
                PaymentResource.storeOrUpdate(
                    payments[i].id, 
                    Object.assign(payments[i], { invoice_id })
                ).then((response) => {
                    payments[i] = response.data;
                    savedPayments++;
                    
                    if (savedPayments === payments.length) {
                        resolve(payments)
                    }
                }, reject);
            }

        }, reject);
    })
}